import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";

const initialState: PoEState = {
  statistics: undefined,
  ports: [],
};

const getters: GetterTree<PoEState, RootState> = {
  statistics(state: PoEState): PoEStatistics | undefined {
    return state.statistics;
  },
  ports(state: PoEState): PoEPort[] {
    return state.ports;
  },
};

const mutations: MutationTree<PoEState> = {
  RESET(state: PoEState) {
    state.statistics = undefined;
    state.ports = [];
  },

  SET_STATISTICS(state: PoEState, payload: PoEStatistics) {
    state.statistics = payload;
  },

  SET_PORTS(state: PoEState, payload: PoEPort[]) {
    state.ports = payload;
  },
  UPDATE_PORT(state: PoEState, payload: PoEPort) {
    const index = state.ports.findIndex((model: PoEPort) => model.port_number === payload.port_number);

    if (index === -1) {
      state.ports.push(payload);
    } else {
      state.ports[index] = payload;
    }
  },
};

const actions: ActionTree<PoEState, RootState> = {
  reset({ commit }) {
    commit("RESET");
  },

  read({ commit, rootState, state }) {
    if (state.statistics) {
      return new Promise((resolve) => resolve(this.getters["poe/statistics"]));
    }

    return rootState.api
      .get(`poe`)
      .then((response: { data: PoEStatistics }) => {
        commit("SET_STATISTICS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  update({ commit, rootState }, payload: PoEStatistics) {
    return rootState.api
      .put(`poe`, payload)
      .then((response: { data: PoEStatistics }) => {
        commit("SET_STATISTICS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  updatePorts({ commit, rootState }, payload: PoEPort[]) {
    return rootState.api
      .put(`poe/ports`, payload)
      .then((response: { data: PoEPort[] }) => {
        commit("SET_PORTS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  updatePort({ commit, rootState }, payload: PoEPort) {
    return rootState.api
      .put(`poe/ports/${payload.port_number}`, payload)
      .then((response: { data: PoEStatistics }) => {
        commit("UPDATE_PORT", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },

  ports({ commit, rootState, state }, stash?: boolean) {
    if (state.ports.length > 0 && !stash) {
      return new Promise((resolve) => resolve(this.getters["poe/ports"]));
    }

    return rootState.api
      .get(`poe/ports`)
      .then((response: { data: PoEStatistics }) => {
        commit("SET_PORTS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
